module.exports = __webpack_public_path__ + "files/laurans.8236c76c08da754dc8b884bdbd8fe244.pdf";